<template>
  <div class="container-fluid">
    <div class="card">
      <div class="card-header">
        <p>{{ $t("search") }}</p>
      </div>
      <div class="card-body" style="padding-top: 40px">
        <el-row :gutter="0">
          <el-form
            v-model="SearchFormData"
            ref="elForm"
            :rules="rules"
            size="large"
            label-width="180px"
          >
            <el-col :span="8">
              <el-form-item :label="$t('model')" prop="model">
                <el-input
                  v-model="SearchFormData.model"
                  clearable
                  :style="{ width: '100%' }"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('catlog')" prop="catlogs">
                <el-select
                  @change="selectChange"
                  v-model="SearchFormData.catlog"
                  :placeholder="$t('pleaseselect')"
                  :style="{ width: '100%' }"
                >
                  <el-option
                    v-for="(item, index) in catlogs"
                    :key="index"
                    :value="item.id"
                    :label="$tt(item.name)"
                  >
                  </el-option>
                  <el-option value="-1" :label="$t('all')"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('status')">
                <el-select
                  v-model="SearchFormData.status"
                  :placeholder="$t('pleaseselect')"
                  clearable
                  :style="{ width: '100%' }"
                >
                  <el-option label="量产" value="量产"></el-option>
                  <el-option label="停产" value="停产"></el-option>
                  <el-option :label="已确认" value="已确认"></el-option>
                  <el-option :label="translateStatus('样品')" value="样品"></el-option>
                  <el-option :label="$t('all')" value=""></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="适用范围">
                <el-select
                  v-model="SearchFormData.limit"
                  :placeholder="$t('pleaseselect')"
                  clearable
                  :style="{ width: '100%' }"
                >
                  <el-option label="客户定制" value="客户定制"></el-option>
                  <el-option label="公版" value="公版"></el-option>
                  <el-option :label="$t('all')" value=""></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="备注" prop="remark">
                <el-input
                  v-model="SearchFormData.remark"
                  clearable
                  :style="{ width: '100%' }"
                >
                </el-input>
              </el-form-item>
            </el-col>

            <el-col
              v-if="[-1, 35, 36, 38, 39, 25, 24].includes(SearchFormData.catlog)"
              :span="8"
            >
              <el-form-item :label="$t('bundrate')">
                <el-select
                  v-model="SearchFormData.more.botelv"
                  :placeholder="$t('pleaseselect')"
                  clearable
                  :style="{ width: '100%' }"
                >
                  <el-option value="125k"></el-option>
                  <el-option value="250k"></el-option>
                  <el-option :label="$t('all')" value="全部"></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col v-if="[36, 24].includes(SearchFormData.catlog)" :span="8">
              <el-form-item :label="$t('maxspeed')">
                <el-select
                  v-model="SearchFormData.more.xiansu"
                  :placeholder="$t('pleaseselect')"
                  clearable
                  :style="{ width: '100%' }"
                >
                  <el-option value="24km/h"></el-option>
                  <el-option value="25km/h"></el-option>
                  <el-option value="32km/h"></el-option>
                  <el-option :label="$t('all')" value="全部"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                v-if="[36, 24].includes(SearchFormData.catlog)"
                :label="$t('lampvoltage')"
              >
                <el-select
                  v-model="SearchFormData.more.dengya"
                  :placeholder="$t('pleaseselect')"
                  clearable
                  :style="{ width: '100%' }"
                >
                  <el-option value="6V"></el-option>
                  <el-option value="12V"></el-option>
                  <el-option value="36V"></el-option>
                  <el-option value="48V"></el-option>
                  <el-option :label="$t('all')" value="全部"></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col v-if="[30, 32].includes(SearchFormData.catlog)" :span="8">
              <el-form-item :label="$t('cablelength')">
                <el-input
                  v-model="SearchFormData.more.changdu"
                  clearable
                  :style="{ width: '100%' }"
                >
                </el-input>
              </el-form-item>
            </el-col>

            <el-col v-if="[30, 32].includes(SearchFormData.catlog)" :span="8">
              <el-form-item :label="$t('CABLEITEM')">
                <el-select
                  v-model="SearchFormData.more.leibie"
                  clearable
                  :style="{ width: '100%' }"
                >
                  <el-option value="电池电源线"></el-option>
                  <!-- <el-option value="码表单根延长线"></el-option> -->
                  <el-option value="单根仪表延长线"></el-option>
                  <el-option value="断路器"></el-option>
                  <el-option value="码表按键一分二延长线"></el-option>
                  <el-option value="单根灯延长线"></el-option>
                  <el-option value="前后灯一分二延长线"></el-option>
                  <el-option value="前后灯刹车灯一分三延长线"></el-option>
                  <el-option value="指拨刹把一分三延长线"></el-option>
                  <el-option value="GEARSENSOR延长线"></el-option>
                  <el-option value="两芯公端二段线"></el-option>
                  <el-option value="三芯母端二段线"></el-option>
                  <el-option :label="$t('all')" value="全部"></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col v-if="[30, 32].includes(SearchFormData.catlog)" :span="8">
              <el-form-item :label="$t('CUSTOMCONNECTOR')">
                <el-select
                  v-model="SearchFormData.more.lianjieqi"
                  clearable
                  :style="{ width: '100%' }"
                >
                  <el-option value="XT60"></el-option>
                  <el-option value="2.8母端插簧"></el-option>
                  <el-option value="SM2A"></el-option>
                  <el-option value="SM2F"></el-option>
                  <el-option value="SM3A"></el-option>
                  <el-option value="子弹头"></el-option>
                  <el-option value="子弹座"></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item
                v-if="[35, 38, 39].includes(SearchFormData.catlog)"
                :label="$t('installationsize')"
              >
                <el-select
                  v-model="SearchFormData.more.chicun"
                  clearable
                  :style="{ width: '100%' }"
                >
                  <el-option value="22.2mm"></el-option>
                  <el-option value="25.4mm"></el-option>
                  <el-option value="31.8mm"></el-option>
                  <el-option :label="$t('all')" value="全部"></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item
                v-if="[35, 38, 39, 41].includes(SearchFormData.catlog)"
                :label="$t('cablemanufacturer')"
              >
                <el-select
                  v-model="SearchFormData.more.zhizaoshang"
                  :placeholder="$t('pleaseselect')"
                  clearable
                  :style="{ width: '100%' }"
                >
                  <el-option value="HT"></el-option>
                  <el-option value="CUS"></el-option>
                  <el-option value="HIGO"></el-option>
                  <el-option :label="$t('all')" value="全部"></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col v-if="[41].includes(SearchFormData.catlog)" :span="8">
              <el-form-item :label="$t('wirediameter')">
                <el-select
                  v-model="SearchFormData.more.xianjing"
                  clearable
                  :style="{ width: '100%' }"
                >
                  <el-option value="3.0"></el-option>
                  <el-option value="3.7"></el-option>
                  <el-option :label="$t('all')" value="全部"></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col v-if="[41].includes(SearchFormData.catlog)" :span="8">
              <el-form-item :label="$t('mountingscrew')">
                <el-select
                  v-model="SearchFormData.more.luosi"
                  :placeholder="$t('pleaseselect')"
                  clearable
                  :style="{ width: '100%' }"
                >
                  <el-option value="M4*12"></el-option>
                  <el-option value="M5*12"></el-option>
                  <el-option :label="$t('all')" value="全部"></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col v-if="[41].includes(SearchFormData.catlog)" :span="8">
              <el-form-item
                :label="$t('cablelength')"
                prop="SearchFormData.more.xianchang"
              >
                <el-col>
                  <el-input
                    v-model="SearchFormData.more.xianchang"
                    clearable
                    :style="{ width: '100%' }"
                  >
                  </el-input>
                </el-col>
                <el-col style="margin-left: 10px">mm</el-col>
              </el-form-item>
            </el-col>
          </el-form>
        </el-row>

        <el-row :gutter="10">
          <el-col style="margin-bottom: 10px" :offset="17" :span="10">
            <el-button type="primary" @click="clickSearch">{{ $t("search") }}</el-button>
            <el-button @click="restoreForm">{{ $t("reset") }}</el-button>
          </el-col>
        </el-row>
      </div>
    </div>

    <div style="margin-top: 30px" class="row">
      <el-pagination
        :current-page="currentPage"
        background
        layout="pager"
        :total="totalCount"
        :page-size="50"
        @current-change="refresh"
      >
      </el-pagination>
    </div>

    <div class="card shadow">
      <div class="card-header py-3">
        <p
          class="m-0"
          style="font-size: 15px; color: var(--bs-body-color); font-weight: bold"
        >
          {{ $t("productbrowsing") }}
          <button
            @click="this.$router.back(-1)"
            class="btn btn-primary"
            type="button"
            style="margin: 0 0 0px 20px"
          >
            {{ $t("back") }}
          </button>
        </p>
      </div>
      <div class="card-body">
        <div
          id="dataTable"
          class="table-responsive table mt-2"
          role="grid"
          aria-describedby="dataTable_info"
          style="overflow-y: hidden"
        >
          <table id="dataTable" class="table my-0">
            <thead>
              <tr>
                <th style="width: 63px">{{ $t("index") }}</th>
                <th>
                  <span>{{ $t("model") }}</span>
                </th>
                <th>{{ $t("catlog") }}</th>
                <th style="width: 50px">{{ $t("picture") }}</th>
                <th>{{ $t("status") }}</th>
                <th>适用范围</th>
                <!-- <th>规格</th> -->
                <th style="max-width: 600px">{{ $t("descript") }}</th>
                <th style="max-width: 300px">{{ $t("remark") }}</th>
                <!-- <th>{{ $t("price") }}</th> -->
                <!--                <th>成本价格</th>-->
                <th>{{ $t("customerID") }}</th>
                <th>{{ $t("bikeID") }}</th>
                <th>认证</th>
                <!-- <th v-if="role.updateProduct">操作</th> -->
              </tr>
            </thead>
            <tbody v-for="(item, index) in TableData" :key="index">
              <tr class="dohighlight" style="height: 1px">
                <td>{{ index + 1 }}</td>
                <td style="font-weight: bold">{{ item.model }}</td>
                <td>{{ $tt(getCatlogName(item)) }}</td>
                <td style="text-align: center">
                  <img
                    @click="imgViewClick(item)"
                    :src="item.picture"
                    style="height: 100px; cursor: pointer; max-width: 200px"
                  />
                </td>
                <td>{{ translateStatus(item.status) }}</td>
                <td>{{ item.limit }}</td>
                <td>
                  <div style="max-width: 600px" v-html="item.description" />
                </td>
                <td style="max-width: 300px; white-space: pre-wrap; text-align: left">
                  {{ item.remark }}
                </td>
                <!-- <td>{{ item.price }}</td> -->
                <!--                <td>{{ item.cost }}</td>-->
                <td style="height: inherit; padding: 0">
                  <div style="height: 100%; display: flex; flex-direction: column">
                    <div
                      style="
                        flex: 1;
                        display: table;
                        margin-bottom: -1px;
                        border-bottom: 1px solid #e3e6f0;
                      "
                      :key="strs"
                      v-for="strs in splitStr(item.customerID)"
                    >
                      <div style="display: table-cell; vertical-align: middle">
                        {{ strs }}
                      </div>
                    </div>
                  </div>
                </td>
                <td style="height: inherit; padding: 0">
                  <div style="height: 100%; display: flex; flex-direction: column">
                    <div
                      style="
                        flex: 1;
                        display: table;
                        margin-bottom: -1px;
                        border-bottom: 1px solid #e3e6f0;
                      "
                      :key="strs"
                      v-for="strs in splitStr(item.bikeID)"
                    >
                      <div style="display: table-cell; vertical-align: middle">
                        {{ strs }}
                      </div>
                    </div>
                  </div>
                </td>

                <td>{{ item.certification }}</td>
                <!-- <td v-if="role.changePrice">
                  <a href="javascript:;" @click="ChangePrice(item)">修改报价</a>
                </td> -->
                <!-- <td v-if="role.updateProduct">
                  <a href="javascript:;" @click="UpdateClick(item)">修改</a>
                  <a
                    href="javascript:;"
                    @click="Delete(item)"
                    style="margin: 0 10px 0"
                    >删除</a
                  >
                </td> -->
              </tr>
            </tbody>
            <tfoot>
              <tr></tr>
            </tfoot>
          </table>
        </div>
        <div class="row">
          <el-pagination
            :current-page="currentPage"
            background
            layout="pager"
            :total="totalCount"
            :page-size="50"
            @current-change="refresh"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
  <el-dialog :fullscreen="true" v-model="showImgDialog">
    <img :src="showingImgSrc" />
  </el-dialog>
</template>

<script>
import {
  DeleteProducts,
  GetProductCatlog,
  GetProductPages,
  ChangePrice,
  SearchProductPages,
} from "../common/httphelper.js";
import Swal from "sweetalert2";
import router from "../router/index.js";
import "../common/role";
import getRole from "../common/role";
import Mark from "mark.js";
//#region
function highlight(text) {
  if (!text) return;
  var trs = document.querySelectorAll("tr.dohighlight");
  trs.forEach((tr) =>
    tr.childNodes.forEach((td) => {
      var instance = new Mark(td);
      instance.mark(text);
    })
  );
}
//#endregion

export default {
  data() {
    return {
      currentPage: 1,
      catlogid: "-1",
      TableData: [],
      totalCount: undefined,
      role: {},
      searchInput: "",
      catlogs: [],
      SearchAllText: "",
      SearchFormData: this.newFormData(),
      searchParam: this.newFormData(),
    };
  },
  methods: {
    refresh(index = 1) {
      this.TableData = [];
      window.scrollTo(0, 0);
      SearchProductPages(this.searchParam.catlog, index, this.searchParam).then((res) => {
        Swal.close();
        this.TableData = res.data.data;
        this.totalCount = res.data.count;
        this.currentPage = index;
      });

      if (this.searchParam.catlog == -2) {
        setTimeout(() => {
          highlight(this.searchParam.model);
        }, 1000);
      }
    },
    splitStr(str) {
      if (!str) {
        return ["/"];
      } else {
        //console.log(str);
        return str.split("/");
      }
    },
    Delete(item) {
      Swal.fire({
        title: "确定删除吗?",
        text: "将创建删除操作的审批流程!",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "删除",
        cancelButtonText: "取消",
      }).then((result) => {
        if (result.isConfirmed) {
          DeleteProducts(item.id).then(async (res) => {
            if (res.data.data) {
              await Swal.fire({
                icon: "success",
                title: "已创建审批流程",
                showConfirmButton: false,
                timer: 3000,
              });
              this.refresh(this.currentPage);
            } else {
              await Swal.fire({
                icon: "error",
                title: res.data.message,
                showConfirmButton: false,
                timer: 3000,
              });
            }
          });
        }
      });
    },
    UpdateClick(item) {
      router.push({
        name: "AddProduct",
        query: {
          name: this.catlogname,
          item: JSON.stringify(item),
        },
      });
    },
    imgViewClick(item) {
      this.$viewerApi({
        options: {
          toolbar: true,
          initialViewIndex: this.TableData.indexOf(item),
        },
        images: this.TableData.map((item) => item.picture),
      });
    },
    restoreForm() {
      this.SearchFormData = this.newFormData();

      this.clickSearch();
    },
    clickSearch() {
      this.SearchFormData.model = this.SearchFormData.model.trim();
      this.searchParam = JSON.parse(JSON.stringify(this.SearchFormData));
      this.refresh(this.currentPage);
    },
    getCatlogName(item) {
      let result = this.catlogs.find((x) => x.id == item.catlogId);
      if (result) return result.name;
      else return "已删除类别";
    },

    async ChangePrice(item) {
      const { value: name } = await Swal.fire({
        title: "价格修改",
        type: "question",
        input: "text",
        inputValue: item.price,
        inputPlaceholder: "请输入产品价格",
        inputAttributes: {
          autocapitalize: "off",
          autocorrect: "off",
        },
        allowOutsideClick: false,
        showCloseButton: true,
        showCancelButton: true,
        cancelButtonText: "取消",
        confirmButtonText: "确定",
      });

      if (!name) {
        return;
      }

      let price = Number(name);
      if (isNaN(price)) {
        await Swal.fire({
          icon: "error",
          title: "请填写正确的数字",
          showConfirmButton: false,
          timer: 1500,
        });
        return;
      }

      ChangePrice({ id: item.id, price: price }).then(async (res) => {
        if (res.data.data) {
          await Swal.fire({
            icon: "success",
            title: "已提交价格修改审批",
            showConfirmButton: false,
            timer: 1500,
          });
        } else {
          await Swal.fire({
            icon: "error",
            title: res.data.message,
            showConfirmButton: false,
            timer: 1500,
          });
        }
      });
    },

    newFormData() {
      return {
        model: "",
        catlog: "-1",
        status: "",
        limit: "",
        remark:"",
        more: {
          botelv: "全部",
          dengya: "全部",
          zhizaoshang: "全部",
          luosi: "全部",
          xiansu: "全部",
          chicun: "全部",
          xianjing: "全部",
          leibie: "全部",
          lianjieqi: "全部",
        },
      };
    },

    selectChange() {
      this.SearchFormData.more = this.newFormData().more;
    },

    translateStatus(status) {
      if (this.$i18n.locale == "English") {
        switch (status) {
          case "在销售":
            return "In sale";
          case "已停产(在维护)":
            return "Discontinued (in maintenance)";
          case "开发中(可送样)":
            return "Developing(sample can be sent)";
          case "开发中(不可送样)":
            return "Developing(sample can't be sent)";

          default:
            break;
        }
      }

      return status;
    },
  },
  async mounted() {
    this.role = getRole();

    await GetProductCatlog().then((res) => {
      this.catlogs = res.data.data;
    });

    if (this.$route.query.catlog > -1) {
      this.searchParam.catlog = this.$route.query.catlog;
      this.SearchFormData.catlog = this.catlogs.find(
        (item) => item.id == this.searchParam.catlog
      ).id;
    }
       
    if (this.$route.query.catlog == -2) {
      this.searchParam.catlog = -2;
      this.searchParam.model = this.$route.query.value;
    }

    this.refresh(this.currentPage);
  },
};
</script>

<style scoped>
.table > :not(:first-child) {
  border-top: 1px solid currentColor;
}
</style>
